<template>
    <div id="messaging">

        <div class="content-wrapper">
            <div class="page-heading">
                <h1 class="page-title">{{$t('message.messaging')}}</h1>
            </div>
            <div class="page-heading">
                <div class="page-content fade-in-up">

                    <div class="ibox">
                        <div class="ibox-body">
                            <div class="row">
                                <div class="col-md-2">
                                    <div class="form-group">
                                        <div class="input-group-icon right">
                                            <div class="input-icon"><i class="fa fa-search"></i>
                                            </div>

                                            <input v-model="projectsFilter" @keyup="filterProjects"
                                                   class="form-control" type="text"
                                                   :placeholder="$t('message.filterProjects')">
                                        </div>
                                    </div>
                                    <div class="list-project-wrapper">
                                        <table class="table table-stripped" style="width: 170px">
                                            <tbody style="font-size: 0.9em">

                                            <tr style="cursor: pointer;"
                                                v-for="(project, index) in projectsFiltered" :key="index">
                                                <td :class="{activeProject: currentProjectIndex === index}"
                                                    @click="setCurrentIndex(index)">{{project.name}}
                                                </td>
                                                <td><span v-if="project.status">{{$t('message.active')}} <button
                                                        style="height: 12px; width: 12px"
                                                        class="btn btn-sm btn-success btn-circle activity-button"></button></span><span
                                                        v-if="!project.status">{{$t('message.notActive')}} <button
                                                        style="height: 12px; width: 12px"
                                                        class="btn btn-sm btn-danger btn-circle activity-button"></button></span>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div class="col-md-9">
                                    <div class="row">
                                        <div style="width: 100%">
                                            <label>{{$t('message.subject')}}:</label>
                                            <input type="text" class="form-control" v-model="email.subject">
                                        </div>
                                        <div style="margin-top: 15px; width: 100%">
                                            <label>{{$t('message.messageBody')}}:</label>
                                            <wysiwyg v-model="email.message_body"/>
                                        </div>
                                        <div style="width: 100%; text-align: center; margin-top: 20px">
                                            <button style="cursor:pointer;" @click="sendMessage"
                                                    class="btn btn-primary">{{$t('message.send')}}
                                            </button>
                                        </div>
                                    </div>


                                    <div v-if="emails.length" class="row" style="margin-top: 20px">
                                        <label>{{$t('message.emailArchive')}}:</label>
                                        <table class="table table-stripped">

                                            <tr v-for="(email, index) in emails" :key="index">
                                                <td>
                                                    <button class="accordion" @click="setEmailActiveIndex(index)">
                                                        {{ formatDateTime(email.date_time) }} | {{ email.subject }}
                                                    </button>
                                                    <div class="panel" v-html="email.message_body"
                                                         :class="{ 'show' : (index === emailActiveIndex) }">
                            
                                                    </div>
                                                </td>
                                            </tr>

                                        </table>
                                    </div>

                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
  import OkModal from '../../modals/OkModal'

  export default {

    props: ['projectId'],
    name: 'MessageSection',
    components: {},
    data () {
      return {
        emailActiveIndex: null,
        projects: [],
        propsArray: [],
        projectsFiltered: [],
        projectsFilter: '',
        currentProject: {},
        currentProjectIndex: -1,
        email: {
          message_body: null,
          subject: null,
          project: null
        },
        emails: []
      }
    },
    created () {
      this.getList(this.apiPrefix, this.projectApiUrl)
        .then(resp => {
          this.projects = resp.data
          this.projectsFiltered = this.projects

          if (this.projects.length) {
            if (!this.projectId) {
              this.currentProjectIndex = 0
            } else {
              const index = this.findByProperty(this.projects, 'id', this.projectId)
              this.currentProjectIndex = index
            }
            this.email.project = this.projects[this.currentProjectIndex].id
            this.getEmailList(this.email.project)
          }
        })
        .catch(err => {
          console.log(err.response)
          this.$modal.show(OkModal, {
              text: this.$t('message.oopsSomethingWentWrong'),
              modalClass: this.modalClasses.okErrorClass
            },
            {
              width: this.modalWidth(),
              height: 'auto'
            })

        })
    },
    methods: {
      setEmailActiveIndex (index) {

        if (this.emailActiveIndex === index)
          this.emailActiveIndex = null
        else
          this.emailActiveIndex = index
        console.log(this.emailActiveIndex)
      },
      formatDateTime (dateTime) {
        return this.$moment(dateTime).format('YYYY-MM-DD HH:mm').toString()
      },
      getEmailList (id) {

        this.getList(this.apiPrefix, this.projectApiUrl + '/get-emails', `?project_id=${id}`)
          .then(resp => {
            this.emails = resp.data
            this.emails.reverse()
          })
          .catch(err => {
            console.log(err.response)
          })

      },
      sendMessage () {
        this.post(this.apiPrefix, this.projectApiUrl + 'send-email', '', this.email).then(() => {

          this.email.subject = null
          this.email.message_body = null

          this.emailActiveIndex = null

          this.$modal.show(OkModal, {
              text: this.$t('message.emailSuccesfullySent'),
              modalClass: this.modalClasses.okSuccessClass
            },
            {
              width: this.modalWidth(),
              height: 'auto'
            })

          this.getEmailList(this.projects[this.currentProjectIndex].id)

        }).catch(err => {
          let msg = this.createErrorMessage(this.parseErrors(err.response.data.errors))

          this.$modal.show(OkModal, {
              text: msg,
              modalClass: this.modalClasses.okErrorClass
            },
            {
              width: this.modalWidth(),
              height: 'auto'
            })
        })
      },
      filterProjects () {
        let filter = this.projectsFilter.toLowerCase()

        this.projectsFiltered = this.projects.filter(project => {
          if (filter === '') {
            return true
          }

          return project.name.toLowerCase().startsWith(filter)
        })
      },
      setCurrentIndex (index) {
        this.currentProjectIndex = index
        this.email.project = this.projects[this.currentProjectIndex].id
        this.getEmailList(this.email.project)

        this.emailActiveIndex = null
      }
    }
  }
</script>

<style scoped>
    @import "~vue-wysiwyg/dist/vueWysiwyg.css";

    td, th {
        padding: 3px 9px;
    }

    .list-project-wrapper {
        max-height: 850px;
        overflow-y: auto;
    }

    .activeProject {
        color: #0b93d5;
    }

    .doughnut {
        height: 300px;

    }

    .chart-box-wrapper {
        color: grey;
        margin: 2%;
        border: 1px solid rgba(220, 220, 220, 0.6);
        border-radius: 4px;
        box-shadow: 0 5px 5px -3px rgba(0, 0, 0, .2), 0 8px 10px 1px rgba(0, 0, 0, .14), 0 3px 14px 2px rgba(0, 0, 0, .12);
        min-height: 188px;
        padding: 9px;
    }

    .chart-box-wrapper:hover {
        background-color: rgba(220, 220, 220, 0.3);
    }

    th, td {
        margin-right: 2px;
    }

    .sortButton {
        height: 22px;
        width: 30px
    }

    .accordion {
        cursor: pointer;
        border: none;
        outline: none;
        width: 100%;
        text-align: left;
        color: #000;
        padding: 8px;
        margin: 4px 0;
        border-radius: 4px;
        transition: 0.3s;
        background-color: rgba(255, 255, 255, 0.8);

    }

    .accordion:hover {
        background-color: #258CD1;
        color: #fff;
    }

    .accordion.active {
        background-color: #fff;
        color: #000;
        border-radius: 4px 4px 0 0;
        margin: 4px 0 0;
    }

    .panel {
        background-color: #d4d7d8;
        color: #000;
        border-radius: 0 0 4px 4px;
        overflow: hidden;
        opacity: 0;
        max-height: 0;
        transition: 0.3s;
        padding: 0 8px;
        margin: 0;
    }

    .show {
        opacity: 1;
        max-height: 500px;
        padding: 8px;
        margin: 2px 0 4px;
    }

</style>